module.exports = __webpack_public_path__ + "video/600_PAB_2021_IntroducingThePAB.cff344e2.vtt";